var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 4.5625V11.875H4.0625V4.5625H11.375ZM11.375 3.75H4.0625C3.84701 3.75 3.64035 3.8356 3.48798 3.98798C3.3356 4.14035 3.25 4.34701 3.25 4.5625V11.875C3.25 12.0905 3.3356 12.2972 3.48798 12.4495C3.64035 12.6019 3.84701 12.6875 4.0625 12.6875H11.375C11.5905 12.6875 11.7972 12.6019 11.9495 12.4495C12.1019 12.2972 12.1875 12.0905 12.1875 11.875V4.5625C12.1875 4.34701 12.1019 4.14035 11.9495 3.98798C11.7972 3.8356 11.5905 3.75 11.375 3.75Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 7.8125H0.8125V2.125C0.8125 1.90951 0.898102 1.70285 1.05048 1.55048C1.20285 1.3981 1.40951 1.3125 1.625 1.3125H7.3125V2.125H1.625V7.8125Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 4.5625V11.875H4.0625V4.5625H11.375ZM11.375 3.75H4.0625C3.84701 3.75 3.64035 3.8356 3.48798 3.98798C3.3356 4.14035 3.25 4.34701 3.25 4.5625V11.875C3.25 12.0905 3.3356 12.2972 3.48798 12.4495C3.64035 12.6019 3.84701 12.6875 4.0625 12.6875H11.375C11.5905 12.6875 11.7972 12.6019 11.9495 12.4495C12.1019 12.2972 12.1875 12.0905 12.1875 11.875V4.5625C12.1875 4.34701 12.1019 4.14035 11.9495 3.98798C11.7972 3.8356 11.5905 3.75 11.375 3.75Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 7.8125H0.8125V2.125C0.8125 1.90951 0.898102 1.70285 1.05048 1.55048C1.20285 1.3981 1.40951 1.3125 1.625 1.3125H7.3125V2.125H1.625V7.8125Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.cab178c7fdd6b6ae0cf82ce80cf1a9a3.svg";
export { ForwardRef as ReactComponent };